import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HttpCacheClient } from '../../../../shared/http/cache-client';
import { SessionManager } from '../../../../session/service/session-manager';
import { CampaignEntityService } from '../../../campaign-util/shared/campaign-entity';

@Component({
  templateUrl: './solvimon-tabs.component.html',
  styleUrls: ['./solvimon-tabs.component.scss'],
})
export class SolvimonTabsComponent implements OnInit {

  currentUrl: string;
  user: any = {};
  license = null;
  campaign: any = {};

  constructor(private router: Router,
              private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.setCurrentUrl((<any>this.route.snapshot)._routerState.url);
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.setCurrentUrl(event.url);
      }
    });
  }

  setCurrentUrl(url: string) {
    this.currentUrl = url;
  }
}
